import React, { Component } from 'react';

class Home extends Component {

  state = {

  }

  componentDidMount() {

  }

  render() {

    return (
      <div className="HomePage">
                Home
      </div>
    );
  }

}

export default Home;


// WEBPACK FOOTER //
// ./src/components/content/home/home.js